module.exports = __webpack_public_path__ + "img/prod_qr_wa.d3f9b383.png";